export default "__VITE_ASSET__Cd9zZ60U__"